import gql from 'graphql-tag'

export const RULE_INTERVAL_FIELDS = gql`
    fragment RuleIntervalFields on AccessInterval {
        id
        days
        from
        to
        requiresPin
    }
`

export const RULE_FIELDS = gql`
    fragment RuleFields on AccessRule {
        id
        name
        type
        intervals {
            ...RuleIntervalFields
        }
    }
    ${RULE_INTERVAL_FIELDS}
`

export const PROJECT_FIELDS = gql`
    fragment ProjectFields on Project {
        id
        name
        meta {
            can {
                createVirtualCard
                manageAccessGroups
                manageProjectSettings
            }
        }
        settings {
            denyInvalidCards
            denyWithoutPsi
        }
    }
`

export const READER_FIELDS = gql`
    fragment ReaderFields on ProjectReader {
        name
        readerId
        supportsOpeningWithApp
        supportsPin
    }
`

export const GROUP_FIELDS = gql`
    fragment GroupFields on AccessGroup {
        disableAntiPassback
        grantWhenPsiCompleted
        id
        ignoreGeofenceWhenOpeningWithApp
        name
        type
    }
`

export const GROUP_READER_RULE_FIELDS = gql`
    fragment GroupReaderRuleFields on AccessGroupReaderRuleAssociation {
        canBeOpenedWithApp
        groupId
        readerId
        requiresPin
        ruleId
    }
`

export const GROUP_CARD_FIELDS = gql`
    fragment GroupCardFields on AccessGroupCardAssociation {
        groupId
        card {
            externalVisitorCardId
            id
            cardId
            type
            status
            expiresAt
            bklrUserHasCompletedPsi @include(if: $withPsi)
            company {
                id
                name
                nationality
                orgNo
            }
            user {
                avatarFileId
                id
                kind
                name
                primaryEmail
            }
            bklrUser {
                id
                name
            }
        }
    }
`

export const GROUP_COMPANY_FIELDS = gql`
    fragment GroupCompanyFields on AccessGroupCompanyAssociation {
        bklrCompanyName
        bklrInternalCompanyId
        bklrOrgNo
        groupId
        representsAllCompanies
        company {
            id
            name
            nationality
            orgNo
        }
    }
`
